/*export const API_URL = "https://1-dot-sandbox-dot-digitafirma.wl.r.appspot.com/";*/
export const API_URL = process.env.VUE_APP_API_URL;
/*export const API_URL = "http://localhost:8080";*/

export const IS_MAINTENANCE_MODE = process.env.VUE_APP_MAINTENANCE_MODE === 'true';

export const SIGN_STRATEGIES = {
  CLASSIC: "Firma Electrónica Avanzada",
  PDF_SIGNATURE: "Firma Electrónica Avanzada PAdES (PDF)"
}

export const SIGN_POSITION = {
  NONE: "Nueva hoja",
  UPPER_LEFT: "Arriba a la izquierda",
  UPPER_RIGHT: "Arriba a la derecha",
  LOWER_LEFT: "Abajo a la izquierda",
  LOWER_RIGHT: "Abajo a la derecha",
  CUSTOM: "Personalizado",
}

export const INVOICE_STATUS = {
  CREATED: "Creada",
  ISSUED: "Emitida",
  GLOBAL_ISSUED: "Emitida en global"
}

export const SIGN_STATUS = {
  PENDING: "Pendiente",
  SIGNED: "Firmado",
  REJECTED: "Rechazado"
}

export const CONEKTA_API_KEY = "key_bHdk3rAUuqokthZ1gYmcSBQ"
/*export const CONEKTA_API_KEY = "key_F4ooyu5zyRdYMHjtMe2kTqA"*/

export const AVAILABLE_PLANS = {
  demo: 1,
  flexible: 3,
  professional_monthly: 6,
  professional_yearly: 7,
}

export const LEGACY_PLANS = {
  professional_monthly: 2,
  professional_yearly: 4,
}

export const PROVIDER_VERIFICATION = {
  VERIFICAMEX: "VERIFICAMEX",
  LOCAL: "LOCAL",
}
